import axios from '@/axios';

// URL and endpoint constants
// Subjects
const SUBJECTS_URL = '/subjects';

export default {
  // GET
  index(id) {
    return axios.get(`${SUBJECTS_URL}/${id}/traits`);
  },
};



// WEBPACK FOOTER //
// ./src/api/traits.js